import { ChangeDetectionStrategy, Component, Injector, Input } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { chatUserName } from '@shared/model/chat-user.model';

@Component({
  selector: 'chat-card',
  templateUrl: './chat-card.component.html',
  styleUrls: ['./chat-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatCardComponent extends AppComponentBase{
  @Input() user: chatUserName;
  @Input() userIdSelecionado: string;
  @Input() temNotificacoes: boolean;
  @Input() isNew: boolean = false;

  constructor(injector: Injector) {
    super(injector);
  }

  protected truncarNomeEquipe(text: string): string{
    if(!text) return ""
    else if(text.length > 23) return text.substring(0, 20) + "...";
    return text;
  }
}
